function useDeviceType() {
    const userAgent = typeof window.navigator === 'undefined' ? '' : window.navigator.userAgent;
    const mobile = Boolean(userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i));
    return mobile;
}

export { useDeviceType };
